<template>
  <div>
    <div class="cruisePortsBar" @click="openCruisePortsModal">
      <div class="lbl">航程详情</div>
      <img class="icon" :src="`${imgUrl}/global/icons/iconArrowRightBlueMiniPC.png`" alt="" />
    </div>
    <div
        id="informModal"
        class="modal fade"
        :class="{ in: isShowModal, active: isShow }"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
        aria-hidden="true"
        v-show="isShow"
    >
      <div class="modal-bg" @click="close"></div>
      <div class="modal-dialog">
        <div class="cruisePortsModalHeader">航程详情</div>
        <div class="cruisePortsModal">
          <div class="cruisePortsModalScroll">
            <div  class="cruisePortsModalContent">
              <div class='cruisePortsItem' v-for="(item, index) in list" :key="index">
                <div class="cruisePortsItemHeader">
                  <div class='cruisePortsItemIcon' :style="{'background':item.iconColor}">
                    <img class='iconImg' :src="item.iconImg" alt="" />
                  </div>
                  <div class="cruisePortsItemBase">
                    <div>第{{item.day}}天</div>
                    <div class="divideLine"></div>
                    <div>{{item.portDay}}</div>
                    <div class="divideLine"></div>
                    <div><span v-if="item.activity === 'DOCKED' && item.countryName">{{item.countryName}}·</span>{{item.title}}</div>
                  </div>
                </div>
                <!--码头地址-->
                <template v-if="item.showPortAddress && item.address">
                  <div class='cruisePortsItemPortAddress'>码头地址：<div v-html="item.address"></div></div>
                </template>
                <!--港口-->
                <template v-if="item.activity === 'DOCKED'">
                  <div v-if="item.arrivalTime || item.departureTime" class='cruisePortsItemArrivalTime'>
                    <span v-if="item.arrivalTime">{{item.arrivalTime ? '抵港 ' + item.arrivalTimeStr : ''}}</span>
                    <span v-if="item.departureTime">{{item.departureTime ? '启航 ' + item.departureTimeStr : ''}}</span>
                  </div>
                  <template v-if="item.address">
                    <div class='cruisePortsItemPortAddress'>码头地址：<div v-html="item.address"></div></div>
                  </template>
                </template>
              </div>
              <div class="cruisePortsDesc">起航/抵港时间、停靠港及行程可能因特殊情况发生调整，请以实际运营为准。</div>
            </div>
          </div>
        </div>
        <div class="cruisePortsModalBtn" @click="submit">我知道了</div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  name: "CruisePortsPopup",
  props: {
    isSale: {
      type: Boolean,
      default: false
    },
    shipCode: {
      type: String,
      default: ''
    },
    sailDate: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShowModal: false,
      isShow: false,
      list: [],
      imgUrl: process.env.VUE_APP_IMG_URL,
      logoImgUrl: process.env.VUE_APP_LOGO_IMG_URL
    };
  },
  methods: {
    openCruisePortsModal() {
      if(this.isSale) {
        this.$router.push(`/Rccl.Cruise/CruiseDetail?shipCode=${this.shipCode}&sailDate=${this.sailDate}`)
      } else {
        this.open()
      }
    },
    async open() {
      this.$loading.show()
      const {success, data, errMsg} = await api.booking.getCruisePortsDetail({
        shipCode: this.shipCode,
        sailDate: this.sailDate,
        source: 'online'
      })
      this.$loading.hide()
      if (success) {
        this.list = this.formatRows(data);
        this.isShow = true
      } else {
        console.error(errMsg)
      }
    },
    close () {
      this.isShowModal = false;
      setTimeout(() => {
        this.isShow = false;
      }, 100);
    },
    submit() {
      this.close();
    },
    formatRows(rows) {
      rows && rows.forEach((row)=> {
        let code = row.code;
        let title = ""
        if (code && code.indexOf("CRU") >= 0) {
          title = "海上巡航"
        } else {
          if (row.activity === "EMBARK" || row.activity === "DEBARK") {
            title += row.harborCNName
          } else {
            title += row.name
          }
        }
        row.title = title;

        row.arrivalTimeStr = row.arrivalTime && row.arrivalTime.substring(0, 5);
        row.departureTimeStr = row.departureTime && row.departureTime.substring(0, 5);
        row.showPortAddress = !(code && code.indexOf("CRU") >= 0) && (row.activity === 'EMBARK' || row.activity === 'DEBARK');
        row.showDescription = code && code.indexOf("CRU") >= 0;

        console.log(row.activity)
        if (row.activity === 'EMBARK') {
          row.iconImg = this.logoImgUrl + '/logoAnchorWhite.png';
        } else if (row.activity === 'DOCKED') {
          row.iconImg = this.imgUrl + '/global/icons/iconFlag.png';
        } else {
          row.iconImg = this.imgUrl + '/global/icons/iconShip.png';
        }

        switch(row.activity) {
          case 'CRUISING':
            row.iconColor = '#ED9100';
            break;
          case 'DOCKED':
            row.iconColor = '#46A91A';
            break;
          case 'EMBARK':
            row.iconColor = '#001770';
            break;
          default:
            row.iconColor = '#0068b3'
        }
      });
      return rows;
    }
  },
  watch: {
    isShow(newValue) {
      this.isShowModal = newValue;
    },
  },
};
</script>


<style lang="less" scoped>
.modal-dialog {
  top: 128px !important;
  padding: 18px 0 15px 0;
  background-color: #fff;
}

.modal {
  .modal-content {
    min-width: 1086px;
    border-radius: 8px;
    position: relative;
    padding-top: 20px;
    box-sizing: border-box;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 10px;
  }
  .modal-body {
    padding: 0 30px 15px 30px;
  }
  @media (min-width: 768px) {
    .modal-dialog {
      width:773px;
      margin: 0 auto
    }
  }
}

.modal.active {
  display: block;
}

.modal-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.cruisePortsBar {
  display: flex;
  align-items: center;
  gap: 0 3px;
  cursor: pointer;
  margin-top: 5px;
  font-family: PingFangSC, PingFang SC;
  & .lbl {
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    color: #036BB9;
  }
  & .icon {
    height: 14px;
    width: 9px;
  }
}
.cruisePortsModal {
  font-family: PingFangSC, PingFang SC;
  background-color: #fff;
}
.cruisePortsModalHeader {
  margin: 0 19px;
  padding: 0 0 15px;
  font-weight: 600;
  font-size: 26px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  box-sizing: content-box !important;
  color: #282828;
  border-bottom: 1px solid #eee;
}
.cruisePortsModalScroll {
  box-sizing: border-box;
  max-height: 549px;
  //padding: 15px 0;
  overflow-x: hidden;
  overflow-y: auto;
  //background-color: #fff;
}
.cruisePortsModalContent {
  padding: 15px 16px;
}
.cruisePortsModalBtn {
  width: 220px;
  height: 53px;
  font-weight: 600;
  font-size: 21px;
  color: #000000;
  line-height: 53px;
  text-align: center;
  border-radius: 4px;
  margin: 0 auto;
  cursor: pointer;
  background: linear-gradient( 225deg, #FFDB17 0%, #FCBF00 100%);
}
.cruisePortsItem {
  padding: 9px 13px;
  border-radius: 5px;
  background: #F4FBFF;
  &+.cruisePortsItem {
    margin-top: 15px;
  }
}
.cruisePortsItemHeader {
  position: relative;
  display: flex;
  height: 31px;
}
.cruisePortsItemIcon {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  border-radius: 30px;
  position: relative;
  & .iconImg {
    display: block;
    margin: 0 auto;
    height: 20px !important;
  }
}
.cruisePortsItemBase {
  display: flex;
  gap: 9px;
  font-size: 21px;
  font-weight: 400;
  color: #282828;
  line-height: 30px;
  & .divideLine {
    width: 1px;
    height: 16px;
    margin-top: 8px;
    background-color: #8f9295;
  }
}
.cruisePortsItemArrivalTime {
  font-size: 16px;
  margin-top: 9px;
  line-height: 21px;
  & span {
    margin-right: 10px;
  }
}

.cruisePortsItemPortAddress {
  font-size: 16px;
  margin-top: 9px;
  line-height: 21px;
  color: #9B9B9B;
}
.cruisePortsDesc {
  font-family: PingFangSC, PingFang SC;
  width: 100%;
  font-weight: 400;
  font-size: 16px;
  color: #9E9F9E;
  line-height: 16px;
  margin-top: 19px;
  padding-bottom: 28px;
}
</style>